import React, { useCallback, useEffect, useMemo } from 'react';
import { FlatTextInput } from '@common-fe/common-fe';

import { LockboxValidationError, lockboxValidationErrorTitle } from '@/modules/employer/components/Lockbox/lockbox.types';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';

const CheckForBenefitOf = () => {
  const { editableLockbox, validationErrors, setEditableLockbox } = useLockboxDetailsStore();

  const remainder = editableLockbox?.remainder;

  const handleChange = useCallback((value: string) => {
    setEditableLockbox({
      remainder: { ...remainder, benefitOf: value }
    });
  }, [remainder, setEditableLockbox]);

  const errorType = useMemo(() => {
    return validationErrors?.find((error) => error === LockboxValidationError.BENEFIT_OF_REQUIRED) as LockboxValidationError | undefined;
  }, [validationErrors]);

  useEffect(() => {
    if (!editableLockbox?.remainder?.benefitOf) {
      setEditableLockbox({
        remainder: { ...remainder, benefitOf: '' }
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setEditableLockbox, editableLockbox?.remainder?.benefitOf]);

  return (
    <FlatTextInput
      testId="ForBenefitOf"
      name="forBenefitOf"
      placeholder="For benefit of"
      onChange={handleChange}
      value={editableLockbox?.remainder?.benefitOf}
      errorText={errorType ? lockboxValidationErrorTitle?.[errorType] : undefined}
      ellipsisMode
    />
  );
};

export default CheckForBenefitOf;
